<table class="table">
  <thead>
  <tr>
    <th>{{'lang.scheduleDetails.slotType' | translate}}</th>
    <th>{{'lang.scheduleDetails.contentCull' | translate}}</th>
    <th>{{'lang.scheduleDetails.clientCull' | translate}}</th>
    <th>{{'lang.globals.share' | translate}}</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td class="col-md">
      <div class="card mr-1 mb-0"
           style="height: 100%; width: 100%; display: inline-block; overflow: hidden; color:white"
           [ngClass]="util.getSlotType(slot, 'Class')" *ngIf="slot">
          <span [innerHTML]="util.getSlotType(slot, 'Name') | truncate : 25"
                class="d-flex align-items-center justify-content-center px-4 py-3 "></span>
      </div>
    </td>
    <td class="col-md">
      <button disabled class="btn btn-outline-secondary ">
        <sb-icon icon="management"></sb-icon>
        {{slot.contentCull ? (slot.contentCull.name ?
        slot.contentCull.name : '...') : '...'}}
      </button>
    </td>
    <td class="col-md">
      <button [disabled]="true" class="btn btn-outline-secondary ">
        <sb-icon icon="companyClient"></sb-icon>
        {{slot.clientCull ? (slot.clientCull.name ? slot.clientCull.name
        : '...') : '...'}}
      </button>
    </td>
    <td class="col-md">
      {{slot?.share}}&nbsp;&#x25;
    </td>
  </tr>
  </tbody>
</table>
<hr class="border-dashed my-5">
<div class="d-flex justify-content-between align-items-center mb-4">
  <h3>{{'lang.globals.pricing' | translate}} </h3>
  <button *ngIf="!disabled" class="btn btn-danger" (click)="clearForm()">
    <sb-icon icon="trash"></sb-icon>
  </button>
</div>
<form [formGroup]="formBudget">
  <div class="row">
    <div class="col-xl-3">
      <div class="form-group validateMe">
        <label class="form-label" for="BudgetCurrency">{{'lang.budget.currency' | translate}}</label>
        <select id="BudgetCurrency" class="form-select" formControlName="Currency">
          <option *ngFor="let currency of util.currencies" [value]="currency">
            {{currency.name}} ({{currency.symbol}})
          </option>
        </select>
        <span class="form-text text-muted">{{'lang.budget.currency.description' | translate}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4">
      <div class="form-group validateMe">
        <label class="form-label" for="BudgetMinCPM">{{'lang.budget.minCPM' | translate}}</label>
        <div class="input-group">
          <input type="number" id="BudgetMinCPM" class="form-control text-end" formControlName="MinCPM"/>
          <div class="input-group-append">
            <span class="input-group-text h-100">{{BudgetCurrency?.value?.symbol}}</span>
          </div>
        </div>
        <span class="form-text text-muted">{{'lang.budget.minCPM.description' | translate}}</span>
      </div>
    </div>
    <div class="col-xl-4">
      <div class="form-group validateMe">
        <label class="form-label" for="BudgetMinCPMDuration">{{'lang.budget.minCPMDuration' | translate}}</label>
        <div class="input-group">
          <input type="number" id="BudgetMinCPMDuration" class="form-control text-end"
                 formControlName="MinCPMDuration"/>
          <div class="input-group-append">
            <span class="input-group-text h-100">s</span>
          </div>
        </div>
        <span class="form-text text-muted">{{'lang.budget.minCPMDuration.description' | translate}}</span>
      </div>
    </div>
    <div class="col-xl-4">
      <div class="form-group validateMe">
        <label class="form-label" for="BudgetMinCPS">{{'lang.budget.minCPS' | translate}}</label>
        <div class="input-group">
          <input type="number" id="BudgetMinCPS" class="form-control text-end" formControlName="MinCPS"/>
          <div class="input-group-append">
            <span class="input-group-text h-100">{{BudgetCurrency?.value?.symbol}}</span>
          </div>
        </div>
        <span class="form-text text-muted">{{'lang.budget.minCPS.description' | translate}}</span>
      </div>
    </div>
  </div>
</form>
<div class="row">
  <div class="col-2 offset-8">
    <button (click)="closeModal(false)" class="btn btn-hover-primary">
      {{'lang.globals.cancel' | translate}}
    </button>
  </div>
  <div class="col-2">
    <button [disabled]="disabled || getBudgetSubmission()"
            (click)="closeModal(true)"
            class="btn btn-hover-primary">
      {{'lang.globals.apply' | translate}}

    </button>
  </div>

</div>
